import { Link } from 'react-router-dom';
import { Button, DatePicker, Layout, Space } from "antd";
import moment from "moment";
import React, { useState, useEffect, useRef } from "react";
import "./inap-calendar-page.css";
import { getRoomsDetailCalendar } from '../../appRedux/actions/Booking'

const { Header, Footer, Sider, Content } = Layout;
const { RangePicker } = DatePicker;

export const InapCalendarPage = () => {
  const [data, setData] = useState([])
  const [booking, setBooking] = useState([])
  const [roomCount, setRoomCount] = useState(12)
  const [guestCount, setGuestCount] = useState(0)
  const [startDate, setStartDate] = useState(moment().startOf('month'))
  const [endDate, setEndDate] = useState(moment().endOf('month'))
  const prevData = useRef(null)
  const [audio] = useState(new Audio("/counter-up.mp3"))

  const dateFormat = "dddd, D MMMM YYYY";

  function getData() {
    getRoomsDetailCalendar({
      start: startDate.format("YYYY-MM-DD"),
      end: endDate.format("YYYY-MM-DD")
    })
      .then(responseData => {
        prevData.current = data
        setData(responseData)
        setRoomCount(responseData.length)
        let count = 0;
        responseData.forEach(room => {
          count += room.length;
        })
        setGuestCount(count)

        let booking = []
        responseData.forEach((room, index) => {
          booking[index] = {}
          room.forEach(date => {
            let dateStart = date.start
            if (moment(date.start).isBefore(startDate)) {
              dateStart = startDate.format('YYYY-MM-DD')
              if (!booking[index][dateStart])
                booking[index][dateStart] = {}
              booking[index][dateStart]["out"] = true;
            }
            if (!booking[index][dateStart])
              booking[index][dateStart] = {}
            booking[index][dateStart]["in"] = date.name
            booking[index][dateStart]["participant_id"] = date.participant_id
            for (
              let m = moment(dateStart).add(1, 'days');
              m.isSameOrBefore(moment(date.end), 'day');
              m.add(1, 'days')
            ) {
              if (!booking[index][m.format('YYYY-MM-DD')])
                booking[index][m.format('YYYY-MM-DD')] = {};
              booking[index][m.format('YYYY-MM-DD')]["in"] = true;
              booking[index][m.format('YYYY-MM-DD')]["out"] = true;
            }
          })
        })
        setBooking(booking)
      }).catch(e => {
        console.error(e)
      })
  }

  useEffect(() => {
    getData()
  }, [startDate, endDate])

  useEffect(() => {
    if (prevData.current) {
      if (JSON.stringify(data) !== JSON.stringify(prevData.current)) {
        audio.play()
      }
    }
    prevData.current = data
    const timeout = setTimeout(() => { getData() }, 10000)
    return () => clearTimeout(timeout)
  }, [data])

  return <>
    <Layout style={{ minHeight: '100vh', padding: '0.2rem' }}>
      <Header style={{
        backgroundImage: 'linear-gradient(135deg, hsl(0 84% 45%), hsl(0 90% 35%))',
        margin: 0,
        color: 'hsl(0 0% 98%)',
        fontSize: '1.875rem',
        lineHeight: '2.25rem',
        borderRadius: '0.5rem',
        height: '6rem',
      }}>
        <div className="space-align-container">
          <div className="space-align-block">
            <Space align="center">
              <h1 style={{
                margin: 0,
                color: 'hsl(0 0% 98%)',
                fontWeight: 700,
                fontSize: '1.875rem',
                lineHeight: '2.25rem',
              }}>Kalender Kamar Hotel</h1>
              <Button
                type="primary"
                shape="round"
                size='small'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: 'auto',
                  marginBottom: 'auto',
                  columnGap: '0.3rem',
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-users w-4 h-4 mr-1" data-lov-id="src/components/RoomCalendar.tsx:127:16" data-lov-name="Users" data-component-path="src/components/RoomCalendar.tsx" data-component-line="127" data-component-file="RoomCalendar.tsx" data-component-name="Users" data-component-content="%7B%22className%22%3A%22w-4%20h-4%20mr-1%22%7D"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                {guestCount} Tamu
              </Button>
              <Button
                type="primary"
                shape="round"
                size='small'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: 'auto',
                  marginBottom: 'auto',
                  columnGap: '0.3rem',
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-calendar w-4 h-4 mr-1" data-lov-id="src/components/RoomCalendar.tsx:131:16" data-lov-name="Calendar" data-component-path="src/components/RoomCalendar.tsx" data-component-line="131" data-component-file="RoomCalendar.tsx" data-component-name="Calendar" data-component-content="%7B%22className%22%3A%22w-4%20h-4%20mr-1%22%7D"><path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path></svg>
                {roomCount} Kamar
              </Button>
            </Space>
            <br />
            <Space>
              <RangePicker
                format={dateFormat}
                value={[startDate, endDate]}
                onChange={(dates) => {
                  if (dates && dates.length > 0) {
                    setStartDate(dates[0]);
                    setEndDate(dates[1]);
                  }
                }}
              />
            </Space>
          </div>
        </div>
      </Header>
      <Content className="table-container">
        <table className="rounded">
          <thead>
            <tr>
              <th style={{ backgroundColor: '#f4f4f4' }} className="sticky-col">
                <span style={{ width: '1.4rem', transform: 'rotate(-45deg)', display: 'block', fontWeight: 500, color: '#333' }}>
                  Kamar
                </span>
              </th>
              {Array.from({ length: endDate.diff(startDate, 'days') + 1 }).map((_, idx) => {
                const date = moment(startDate).add(idx, 'days');
                return (
                  <th
                    key={date.format('YYYY-MM-DD')}
                    colSpan={2}
                  >
                    {date.format('ddd')}<br />
                    <b>{date.format('D')}</b><br />
                    {date.format('MMM')}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: roomCount }).map((_, roomIdx) => (
              <tr key={roomIdx}>
                <th className="sticky-col">{roomIdx + 1}</th>
                {Array.from({ length: endDate.diff(startDate, 'days') + 1 }).map((_, dayIdx) => (
                  <React.Fragment key={dayIdx}>
                    {(booking[roomIdx] && booking[roomIdx][moment(startDate).add(dayIdx, 'days').format('YYYY-MM-DD')] && booking[roomIdx][moment(startDate).add(dayIdx, 'days').format('YYYY-MM-DD')]["out"]) ? <>
                      <td className="booked">
                      </td>
                    </> : <>
                      <td>
                      </td>
                    </>}
                    {(booking[roomIdx] && booking[roomIdx][moment(startDate).add(dayIdx, 'days').format('YYYY-MM-DD')] && booking[roomIdx][moment(startDate).add(dayIdx, 'days').format('YYYY-MM-DD')]["in"]) ? <>
                      {(booking[roomIdx][moment(startDate).add(dayIdx, 'days').format('YYYY-MM-DD')] && booking[roomIdx][moment(startDate).add(dayIdx, 'days').format('YYYY-MM-DD')]["in"] === true) ? (
                        <td className="booked"></td>
                      ) : (
                        <td className="booked booked-first">
                          <div class="td-wrapper">
                            <span class="td-overlay" style={{ zIndex: (roomIdx + 1) * 10 }}>
                              {(booking[roomIdx][moment(startDate).add(dayIdx, 'days').format('YYYY-MM-DD')]["participant_id"]) ? <>
                                <Link to={"/participant/"+booking[roomIdx][moment(startDate).add(dayIdx, 'days').format('YYYY-MM-DD')]["participant_id"]}>
                                  {booking[roomIdx][moment(startDate).add(dayIdx, 'days').format('YYYY-MM-DD')]["in"]}
                                </Link>
                              </> : <>
                                { booking[roomIdx][moment(startDate).add(dayIdx, 'days').format('YYYY-MM-DD')]["in"] }
                              </>}
                            </span>
                          </div>
                        </td>
                      )}
                    </> : <>
                      <td></td>
                    </>}
                  </React.Fragment>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </Content>
      {/* <Footer style={{ margin: '0.2rem' }}>Footer</Footer> */}
    </Layout>
  </>
}